import type { SortingState } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';

import { SlideOut } from '~/components/SlideOut/SlideOut';
import { FeedbackRequestModal } from '~/modules/artist-roster/components/ArtistDetails/components/FeedbackRequestModal';
import { ArtistHeader } from '~/modules/artist-roster/components/ArtistHeader/ArtistHeader';
import { PreReleaseTable } from '~/modules/artist-roster/components/PreReleaseTable/PreReleaseTable';
import { TrackPreReleaseBenchmarkPanel } from '~/modules/artist-roster/components/TrackPreReleaseList/TrackPreReleaseBenchmarkPanel';
import type { ArtistDetails } from '~/modules/artist-roster/lib/types';
import { useAnalytics } from '~/modules/monitoring/analytics/useAnalytics';

import { PreReleaseTableHeader } from '../PreReleaseTable/PreReleaseTableHeader';

export function ArtistPreReleasesPage() {
  const { trackEvent } = useAnalytics('Artist Roster');
  const [isSlideOutOpen, setIsSlideOutOpen] = useState(false);

  const handleSetBenchmarkButtonClick = () => {
    setIsSlideOutOpen(true);
  };

  const { artistData, scrollUpCallback } = useOutletContext<{
    artistData: ArtistDetails;
    scrollUpCallback: () => void;
  }>();

  useEffect(() => {
    if (artistData) {
      trackEvent('artistPreReleasesView', {
        artist_id: artistData.partyId,
        artist_name: artistData.name,
      });
    }
  }, [trackEvent, artistData]);

  const [sortingState, setSortingState] = useState<SortingState>([
    {
      id: 'initialReleaseDate',
      desc: true,
    },
  ]);

  return (
    <>
      <ArtistHeader {...{ artistData }}>
        <PreReleaseTableHeader
          uaid={artistData.uaid}
          artistData={artistData}
          columnSort={sortingState[0]}
          scrollUpCallback={scrollUpCallback}
        />
      </ArtistHeader>
      <div className="px-xl pb-xl">
        <PreReleaseTable
          uaid={artistData.uaid}
          artistData={artistData}
          columnSort={sortingState[0]}
          onSortingChange={setSortingState}
          handleSetBenchmarkButtonClick={handleSetBenchmarkButtonClick}
        />
        <SlideOut
          {...{
            open: isSlideOutOpen,
            onOpenChange: setIsSlideOutOpen,
            panelWidth: '1080px',
          }}
        >
          <TrackPreReleaseBenchmarkPanel {...{ artistData }} />
        </SlideOut>
      </div>
      <FeedbackRequestModal />
    </>
  );
}

ArtistPreReleasesPage.displayName = 'ArtistPreReleasesPage';
